<template>
  <div id="app">
    <span v-if="isLoggedIn">
      <app-top-bar></app-top-bar>
      <br /><br /><br />
    </span>
    <div
      class="container is-fluid"
      style="padding-left: 5px; padding-right: 5px"
    >
      <router-view />
      <hr />
      <p style="font-size: 10px">
        Copyright ANSI Dev Team |
        <router-link :to="{ name: 'Release Notes' }">Release Notes</router-link>
      </p>
      <br />
    </div>
  </div>
</template>

<style>
.table-column-content-is-small {
  font-size: 12px;
}
</style>


<script>
import Topbar from "./components/Layout/TopBar.vue";
import AuthService from "./_services/auth";

const authService = new AuthService();

export default {
  data() {
    return {
      isLoggedIn: authService.isLoggedIn(),
    };
  },
  components: {
    appTopBar: Topbar,
  },
};
</script>

<style>
/* b table custom style */
.btablecolumn-custom {
  font-size: 12px;
}
</style>

